module.exports = __webpack_public_path__ + "static/media/fleche-lire-plus-white.747204fd.svg";